// extracted by mini-css-extract-plugin
export var filterIncDec = "_bx-0";
export var leftBorder = "_bx-1";
export var rightBorder = "_bx-2";
export var stringInput = "_bx-3";